module.exports = __webpack_public_path__ + "img/image-spin.93be938e.svg";